import configureStore from './ConfigureStore';

const { store, persistor } = configureStore();

// This function was added only for testing and demo purposes.
// It's used for simulating the scenario when the authentication token expires.
window.__SET_EXPIRED_TOKEN__ = () => {
  store.dispatch({ type: 'SET_EXPIRED_TOKEN' });
};

export { store, persistor };
